import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export enum ChipSize {
  LARGE = 'large',
  SMALL = 'small',
}

export enum ChipColor {
  BLUE = 'blue',
  NAVY = 'navy',
  NEUTRAL = 'neutral',
  HYPER_BLUE = 'hyper-blue',
}
@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
})
export class ChipComponent {
  @Input() value: string;
  @Input() size: ChipSize;
  @Input() color: ChipColor;
  chipClass = '';
  notAvailable = '';

  formatValue(status: string): string {
    return status?.replace(/([A-Z])/g, ' $1').trim();
  }
}
